import 'semantic-ui-css/semantic.min.css'
import { React,useState,useEffect } from 'react';
//import data from './' + process.env.PUBLIC_URL + '/data/epublicaties.json'
import { Grid , Image , Header , Dropdown, Divider , Button, Modal , Message} from 'semantic-ui-react';
import Profiel from './Profiel';
//const pub = process.env.PUBLIC_URL
import './translations/i18n';
import { useTranslation  } from 'react-i18next';
import { useLocation } from 'react-router'
import logoMediaLibrary_en from './assets/no-image-logo-media-library-logo-960x192_en.png';
import logoMediaLibrary_nl from './assets/no-image-logo-media-library-logo-960x192_nl.png';

import logoAUAS_en from './assets/artevelde-logo-467x192_en.png';
import logoAUAS_nl from './assets/artevelde-logo-467x192_nl.png';

import logoEpub from './assets/digital-collection-logo.png'

const lang = [
    'en' , 'nl'
]

const languages = [
    { key : 'nl' , text : 'Nederlands' , value : 'nl' , flag : 'be' , title  : 'Arteveldehogeschool Mediatheken - Epublicaties' },
    { key : 'en' , text : 'English' , value : 'en' , flag : 'gb' , title : 'Artevelde UAS Libraries - Epublications'}
]

const pjson = require('../package.json')
const homep = (!!pjson.homepage) ? pjson.homepage : '/'

const meldingenApiUrl = (process.env.NODE_ENV === 'development') ? 'http://localhost/mediatheken/meldingen' : `https://lib.arteveldehogeschool.be/mediatheken/meldingen` 

const ApplicationHeader = ({user}) => {
    const { t , i18n } = useTranslation();
    const location = useLocation()
    const [ locale , setLocale ] = useState(localStorage.getItem('i18nextLng'))
    i18n.on('languageChanged', (lng) => setLocale(lng))
    const logoMediaLibrary = (locale === 'nl') ? logoMediaLibrary_nl : logoMediaLibrary_en;
    const logoAUAS = (locale === 'nl') ? logoAUAS_nl : logoAUAS_en;
    const handleChange = (e, {  value }) => { i18n.changeLanguage(value) }
    const [ modalOpen , setModalOpen ] = useState(false)

    const [ meldingen , setMeldingen ] = useState([]) 
    const [ hideMelding , setHideMelding] = useState(sessionStorage.getItem('epub_hidden') ? JSON.parse(sessionStorage.getItem('epub_hidden')) : [])

    useEffect( () => {
        if(sessionStorage.getItem('epub_meldingen')) {
            setMeldingen(JSON.parse(sessionStorage.getItem('epub_meldingen')))
        } else {
            fetch(`${meldingenApiUrl}/getSiteMeldingen/epub/`)
        .then((result) => result.json())
        .then((response) => {
            if(!!!response.error) {
                response.map((m) => {
                    setMeldingen(arr => ([
                        ...arr ,
                        m
                    ]))
                })
                sessionStorage.setItem('epub_meldingen',JSON.stringify(response))
                }
            })
        }
    },[])

    const handleDismiss = (slug) => {
        let arr = meldingen
        let hidden = hideMelding
        let idx = arr.findIndex(a => a.slug === slug)
        hidden.push(idx)
        setHideMelding(arr => ([
            ...arr , 
            idx
        ]))
        sessionStorage.setItem('epub_hidden',JSON.stringify(hidden))
    }

    return (
        <>
        <Grid
        verticalAlign='middle' 
            as='header'
            padded
            stackable
            columns='equal'
        >
        <Grid.Row>
            <Grid.Column>
                <Dropdown 
                    closeOnChange
                    fluid
                    selection
                    options={languages}
                    value={locale}
                    onChange={handleChange}
                />        
            </Grid.Column>
            <Grid.Column width={3}>
                <Button
                    color='blue' 
                    inverted
                    fluid
                    icon={!!user ? 'user' : 'key'} 
                    content={!!user ? user.loginData_givenName : t('login')} 
                    onClick={() => setModalOpen(!modalOpen)}
                />
            </Grid.Column>
        </Grid.Row>
        
        <Grid.Column
            width={2}
            textAlign='center'
        >
                <Image
                    src={logoEpub}
                    
                />
        </Grid.Column>  
        <Grid.Column
            width={8}
            textAlign='left'
        >
                <Header as='h1' style={{fontSize : '4em'}}>{t('MainTitle')}</Header>
        </Grid.Column>
        <Grid.Column
            width={3}
            only='computer tablet'
            textAlign='center'
        >
            <Image
                src={logoAUAS}
                as='a'
                href='https://arteveldehogeschool.be/'
                target='_blank'
            />
        </Grid.Column>
        <Grid.Column
            width={3}
            only='computer tablet'
            textAlign='center'
        >
        <Image
            src={logoMediaLibrary}
            as='a'
            href='https://mediatheken.arteveldehogeschool.be/'
            target='_blank'
        />
        </Grid.Column>
    </Grid>
     
    <Profiel 
        user={user}
        modalOpen={modalOpen}
        onModalClose={(b) => setModalOpen(b)}
    />
    <Grid.Row>
        {location.pathname !== `${homep}login` && meldingen.length > 0 &&
            meldingen.map((m,i) => {
                if(!!!hideMelding.includes(i)) {
                return <Message 
                        header={m.titel}
                        content={m.bericht}
                        icon={m.type}
                        onDismiss={!!!m.fixed ? () => handleDismiss(m.slug) : false}
                    />
                }
            })
        }
        </Grid.Row>
        <Divider />
    </>
    );
}

export default ApplicationHeader;